<template>
   <component :is="view" />
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   computed: {
      ...mapGetters(['isAdmin', 'isStaff', 'isCustomer', 'isSME', 'isExternalPartner']),
      view() {
         if (this.isStaff || this.isExternalPartner) {
            return 'StaffDashboard';
         } else if (this.isCustomer) {
            return 'CustomerDashboard';
         } else if (this.isSME) {
            return 'SmeDashboard';
         } else if (this.isAdmin) {
            return 'AdminDashboard';
         } else {
            return 'Users';
         }
      },
   },
};
</script>
